import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Typography } from '@mui/material'
import * as Modal from '_components/modal/generic-modal'
import { useToast } from '_/hooks/use-toast'
import { createAnticipationsTradesman } from '_/modules/finance/actions'
import { formatErrorMessage } from '_/views/finance/utils/FormatErrorMessage'
import { formatCurrency } from '_/utils/helpers'
import { Loader } from '@refera/ui-web'
import useStyles from './styles'

export function PaymentAnticipationModal({ open, onClose, serviceOrderId, anticipationInfo }) {
  const styles = useStyles()
  const dispatch = useDispatch()
  const { showToast } = useToast()

  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = useCallback(async () => {
    setIsLoading(true)
    const payload = {
      serviceOrderId,
    }
    try {
      await dispatch(createAnticipationsTradesman(payload))
      setIsLoading(false)
      showToast({
        type: 'success',
      })
      onClose()
    } catch (error) {
      setIsLoading(false)
      showToast({
        message: formatErrorMessage(error),
        type: 'error',
      })
    }
  }, [dispatch, serviceOrderId, onClose, showToast, formatErrorMessage])

  const anticipationFee = formatCurrency(anticipationInfo?.anticipationDiscount || 0)
  const releaseBusinessDays = anticipationInfo?.anticipationReleaseBusinessDays ?? '--'

  return (
    <>
      <Loader hasBackdrop open={isLoading} />
      <Modal.Root open={open} onClose={onClose}>
        <Modal.TitleModal title="Solicitar antecipação" />

        <Modal.Content className={styles.content}>
          <Typography className={styles.subtitle}>
            Você quer receber o valor antecipadamente?
          </Typography>

          <Typography className={styles.text}>
            Ao aceitar, você confirma seu pedido de antecipação do pagamento referente ao chamado{' '}
            {serviceOrderId}
          </Typography>
          <Typography className={[styles.text, styles.emphasis]}>Atenção</Typography>
          <Typography className={styles.text}>
            Você receberá o valor antecipado com uma taxa de {anticipationFee}{' '}
            <span className={styles.required}>*</span>
            que será descontada de seu pagamento. Os recursos serão liberados em{' '}
            {releaseBusinessDays} dia(s) útil(eis).
          </Typography>

          <Typography className={styles.text}>
            <span className={styles.required}>*</span> Importante: Esta taxa pode variar em até 10%,
            para mais ou para menos. Entre em contato com o Suporte para saber mais.
          </Typography>
        </Modal.Content>
        <Modal.Actions>
          <Modal.ButtonRed onClick={onClose}>Cancelar</Modal.ButtonRed>
          <Modal.ButtonFullBlue onClick={handleSubmit}>Salvar</Modal.ButtonFullBlue>
        </Modal.Actions>
      </Modal.Root>
    </>
  )
}
